



















import colorable from '../../mixins/colorable/colorable';
import mixins from '../../mixins';

export default mixins(colorable).extend({
  mixins: [colorable],
  props: {
    value: { default: false, type: Boolean },
    label: { default: '', type: String },
    required: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    color: { default: 'interaction', type: String },
  },
  data: () => ({
    sliderStyles: {} as Record<string, string>,
    sliderClasses: {} as Record<string, boolean>,
  }),
  watch: {
    color: {
      immediate: true,
      handler() {
        this.sliderStyles = {};
        this.sliderClasses = {};
        const isCssColor = !!this.color && !!this.color.match(/^(#|(rgb|hsl)a?\()/);
        if (isCssColor) {
          this.sliderStyles.color = `${this.color} !important`;
          this.sliderStyles['caret-color'] = `${this.color} !important`;
        } else if (this.color) {
          this.sliderClasses[`text-color-${this.color}`] = true;
        }
      },
    },
  },
  computed: {
    styleList(): Record<string, string> {
      return {
        ...this.sliderStyles,
      };
    },
    classList(): Record<string, boolean> {
      return {
        'p-toggle': true,
        disabled: this.disabled,
      };
    },
    sliderClassList(): Record<string, boolean> {
      return {
        slider: true,
        ...this.sliderClasses,
      };
    },
  },
  methods: {
    onInput(event: InputEvent) {
      const target = event.target as HTMLInputElement;
      this.$emit('input', target.checked);
    },
  },
});
